import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

export class TouchFormControl extends FormControl {
  public touchedChanges: Subject<boolean> = new Subject<boolean>();

  markAsTouched({ onlySelf }: { onlySelf?: boolean } = {}): void {
    super.markAsTouched({ onlySelf });

    this.touchedChanges.next(true);
  }
}
